// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import "./permission"; //引入vue-router导航守卫
import store from './store'
import registerSvgIcon from './icons';
// Vuetify
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import "@/styles/index.scss";
import promptPlugin from './plugins/promptPlugin';
import axiosPlugin from './plugins/axiosPlugin';
import socketPlugin from './plugins/socketPlugin';
import navPlugin from './plugins/navPlugin'; // 导入导航插件
import MapPlugin from './plugins/mapPlugin';
import 'dayjs/locale/zh-cn';//中文
import locale from "element-plus/es/locale/lang/zh-cn";
import moment from "moment";
import "moment/locale/zh-cn";
import './utils/rem.js'; //中引入rem.js
import printPlugin from './plugins/printPlugin'

moment.locale('zh-cn')
const app = createApp(App)
for (const [name, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(name, component);
}

app
    .use(router)
    .use(store)
    .use(promptPlugin)
    .use(axiosPlugin)
    .use(ElementPlus, { locale })
    .use(socketPlugin)
    .use(MapPlugin)
    .use(printPlugin)
    .use(navPlugin) // 使用导航插件
    .mount('#app');
registerSvgIcon(app)

